module.exports = __webpack_public_path__ + "media/images/navigation/gigs-hover-03ef7bd8681e0e6d80a14fc4b3e9041f.gif";